<template>
<!-- App is a mounted component -->
   <router-view/>
</template>